/* eslint-disable no-new-func */
/* eslint-disable no-new */
import '../webpackPublicPath';
import dynamicImportPolyfill from 'dynamic-import-polyfill';
import { startup } from '@root/src/web/browser/startup';
// Provides an import function to use for dynamic imports. **Only works on
// browsers that cut the mustard (support modules).**
const initialiseDynamicImport = () => {
    try {
        window.guardianPolyfilledImport = new Function('url', `return import(url)`);
    }
    catch (e) {
        dynamicImportPolyfill.initialize({
            importFunctionName: 'guardianPolyfilledImport',
        });
    }
};
// Provides an import function to use for dynamic imports. **Designed for
// legacy browsers. Dynamic loads a ~4k bundle.**
const initialiseDynamicImportLegacy = () => {
    return import(/* webpackChunkName: "shimport" */ '@guardian/shimport').then((shimport) => {
        shimport.initialise(); // note this adds a __shimport__ global
        window.guardianPolyfilledImport = shimport.load;
    });
};
const init = () => {
    window.guardianPolyfilledImport = (url) => Promise.reject(new Error(`import not polyfilled; attempted import(${url})`));
    if (window.guardian.mustardCut) {
        return Promise.resolve(initialiseDynamicImport());
    }
    return initialiseDynamicImportLegacy();
};
startup('dynamicImport', null, init);
